import { AuthSessionApi } from '@arbihunter/api-client';
import { Console, Effect, pipe } from 'effect';
import { api } from 'shared/api';
import { SessionResponseDto } from './models';
export { AuthResponseDTO, AuthVerificationResponseDTO } from '@arbihunter/api-client';

export const getCurrentSession = (): Effect.Effect<SessionResponseDto, Error> =>
  pipe(
    Effect.tryPromise(async () => await api.run(AuthSessionApi).get0()),

    Effect.tap((data) => console.log('[getCurrentSession] API call result:', data)),

    Effect.onError((error) => Console.error('[getCurrentSession] Error occurred:', error)),

    // Effect.map(({ profile, session, token }): SessionResponseDto => ({ profile, session, token })),
  );
